<template>
  <v-dialog v-model="visible" persistent max-width="445">
    <v-card class="v-dialog--custom" v-if="visible">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title my-2">{{ $t(`${namespace}.cancelRide`) }}</span>
        <v-btn :disabled="isLoading" class="v-dialog--custom__close mr-2" fab flat color="gray-6" @click="closeDialog">
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text
        v-if="ride && ride.employeeName"
        class="px-4 pt-0"
        v-html="$t(`${namespace}.cancelRideConfirmMessage`).replace('[EMPLOYEE_NAME]', `<strong>${ride.employeeName}</strong>`)"
      />

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer />
        <a
          v-if="!isLoading"
          href="#"
          class="text--normal accent--text mr-4"
          color="accent"
          flat
          round
          @click.prevent="closeDialog"
        >
          {{ $t('Common.cancel') }}
        </a>
        <v-btn
          :disabled="isLoading"
          :loading="isLoading"
          round
          depressed
          color="accent"
          @click.native="cancelRide"
        >
          {{ $t(`${namespace}.cancelRide`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'CancelRideDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    ride: {
      type: Object
    }
  },
  computed: {
    rideId () {
      return this.ride && this.ride.running && this.ride.running.rideID
        ? this.ride.running.rideID
        : null
    }
  },
  data () {
    return {
      namespace: 'Views.NewWebCallPage.cancelRideDialog',
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      successAlert: 'snackbarAlert/success',
      errorAlert: 'snackbarAlert/error'
    }),

    closeDialog () {
      this.$emit('closeDialog')
    },

    async cancelRide () {
      this.isLoading = true

      try {
        await this.$apiService.cancelRide(this.rideId)
        this.closeDialog()
        this.successAlert(this.$t(`${this.namespace}.cancelRideSuccess`))
        this.$emit('updateRidesList')
        this.isLoadingStatus = true
      } catch (err) {
        this.errorAlert(this.$t(`${this.namespace}.cancelRideError`))
        console.log(err)
      }

      this.isLoading = false
    }
  }
}
</script>
